module.exports = __webpack_public_path__ + "static/media/right-tray.15c18111.svg";